import angular from 'angular';
import { Transition } from 'angular-ui-router';

angular.module('history', ['application']);

angular.module('history').config(["$stateProvider", "$translatePartialLoaderProvider", function ($stateProvider: any, $translatePartialLoaderProvider: any) {
    $translatePartialLoaderProvider.addPart('history');

    $stateProvider.state('app.history', {
        url: '/history',
        redirectTo: 'app.new.history.sales'
    });

    $stateProvider.state('app.history.e_invoices', {
        url: '/e-invoices',
        // redirectTo: 'app.new.history.module.e_invoices',
        redirectTo: async (trans: any) => {
            const injector = trans.injector();
            const sessionManager = injector.get('sessionManager');
            const startup = injector.get('startup');
            const checkManager = injector.get('checkManager');
            const entityManager = injector.get('entityManager');
            const userActiveSession = injector.get('userActiveSession');
            const feature = 'history.e_invoices';
            
            try {
                await sessionManager.checkLastActiveSession();

                const user = await entityManager.userSessions.getActiveSession();
                if (user) {
                    userActiveSession.setSession(user);
                }

                await startup.loadUserSettings();
                await startup.loadShopSettings();

                await checkManager.init();

                const isAngular = checkManager.isModuleAngular(feature);

                if (isAngular) {
                    return 'app.new.history.module.e_invoices';
                }

            } catch (e) { }

            return undefined;
        },
        views: {
            "appContent@app": {
                template: require('./partial/history-e-invoices/history-e-invoices.html'),
                controller: 'HistoryEInvoicesCtrl'
            }
        }
    });

    $stateProvider.state('app.history.e_invoices_passive', {
        url: '/e-invoices/passive',
        views: {
            "appContent@app": {
                template: require('./partial/history-e-invoices-passive/history-e-invoices-passive.html'),
                controller: 'HistoryEInvoicesPassiveCtrl'
            }
        }
    });

    $stateProvider.state('app.new.history', {
        url: '/history',
        abstract: true,
        template: `<div class="tw-h-full" ui-view></div>`
    });

    $stateProvider.state('app.new.history.module', {
        url: '',
        abstract: true,
        template: `<history-module></history-module>`,
        // redirectTo: 'app.new.history.module.sales'
    });

    $stateProvider.state('app.new.history.module.sales', {
        url: '/sales',
        params: { id: { type: 'int', value: null }, showToBeInvoiced: false }
    });

    $stateProvider.state('app.new.history.module.sales_data_sent', {
        url: '/sales-data-sent'
    });

    $stateProvider.state('app.new.history.module.e_invoices', {
        url: '/e-invoices'
    });

    $stateProvider.state('app.new.history.sales', {
        url: '/sales',
        params: {
            id: { type: 'int', value: null },
            showToBeInvoiced: { type: 'bool', value: false }
        },
        component: 'historySalesShowcase'
    });

    $stateProvider.state('app.new.history.sale', {
        url: '/sale/:id',
        params: {
            id: { type: 'int', value: null },
        },
        redirectTo: function (transition: Transition) {
            return transition.router.stateService.target('app.new.history.sales', transition.params(), { reload: 'app.new.history' });
        }
    });

    $stateProvider.state('app.new.history.customer', {
        url: '/sale/customer',
        params: {
            customer: null,
            salesToBeInvoicedCustomer: null
        },
        component: 'historySalesShowcase'
    });

    $stateProvider.state('app.new.history.cash-movements', {
        url: '/cash-movements',
        component: 'historyCashMovements'
    });

    $stateProvider.state('app.new.history.products-deleted', {
        url: '/products-deleted',
        component: 'historyProductsDeleted'
    });

    /* Add New States Above */
}]);
